import {css} from 'lit'; export default css`:host{z-index:202;align-self:center;bottom:0;left:75px;list-style-type:none;margin:0 0 var(--goto-spacing-06) calc(72px + var(--goto-spacing-06));position:fixed}`;
    